import { useDispatch } from "react-redux";
import { AppDispatch } from "./Store";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export const useThunkDispatch = () => useDispatch<AppDispatch>();
